import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'badge-palito-premiado',
  templateUrl: './badge-palito-premiado.component.html',
  styleUrls: ['./badge-palito-premiado.component.scss'],
})
export class BadgePalitoPremiadoComponent implements AfterViewInit, OnInit {
  @ViewChild('sorvetePremiado') sorvetePremiado!: ElementRef;
  @ViewChild('closeTag') closeTag!: ElementRef;
  porcentagemScroll: number = 0;

  public desabilitar: boolean = false;

  public currentRoute: string;

  constructor(private renderer: Renderer2, private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = this.router.url;

        if (this.isHiddenTagValid()) {
          this.desabilitar = true;
        } else {
          localStorage.removeItem('hiddenTag');
          let rotas = [
            '/home',
            '/index',
            '/momentos-especiais',
            '/missoes',
            '/beneficios',
          ];
          if (rotas.includes(this.currentRoute)) {
            this.desabilitar = false;
          } else {
            this.desabilitar = true;
          }
        }
      }
    });
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    if (this.isHiddenTagValid() == true) {
      this.desabilitar = true;
    } else {
      if (this.sorvetePremiado) {
        this.iniciarAnimacaoAIntervalosAleatorios();
      }
      if (this.closeTag) {
        this.iniciarAnimacaoAIntervalosAleatorios();
      }
    }
  }

  public navigateToPalitoPremiado(): void {
    this.router.navigate(['/palito-premiado']);
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: any): void {
    if (this.sorvetePremiado && this.renderer) {
      const scrollOffset = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      this.porcentagemScroll =
        (scrollOffset / (documentHeight - windowHeight)) * 100;

      if (this.porcentagemScroll > 90) {
        this.renderer?.setStyle(
          this.sorvetePremiado?.nativeElement,
          'transform',
          'translateY(-10rem)'
        );
        this.renderer?.setStyle(
          this.closeTag?.nativeElement,
          'transform',
          'translateY(-10rem)'
        );
      } else if (this.porcentagemScroll <= 90) {
        this.renderer?.setStyle(
          this.sorvetePremiado?.nativeElement,
          'transform',
          'translateY(0rem)'
        );
        this.renderer?.setStyle(
          this.closeTag?.nativeElement,
          'transform',
          'translateY(0rem)'
        );
      }
    }
  }

  private iniciarAnimacaoAIntervalosAleatorios(): void {
    this.adicionarAnimacao(); // Adiciona animação imediatamente

    setInterval(() => {
      this.adicionarAnimacao();
    }, this.obterIntervaloAleatorio());
  }

  private adicionarAnimacao(): void {
    const elemento = this.sorvetePremiado?.nativeElement;
    const closeTag = this.closeTag?.nativeElement;

    if (elemento != null && closeTag != null) {
      this.renderer?.addClass(elemento, 'bounceIn');
      this.renderer?.addClass(closeTag, 'bounceIn');
    }

    // Aguarde o término da animação (1 segundo) e remova a classe
    setTimeout(() => {
      this.removerAnimacao(elemento);
      this.removerAnimacao(closeTag);
    }, 1000);
  }

  private removerAnimacao(elemento: HTMLElement): void {
    if (elemento != null) {
      this.renderer?.removeClass(elemento, 'bounceIn');
    }
  }

  private obterIntervaloAleatorio(): number {
    return Math.floor(Math.random() * (7000 - 2000 + 1)) + 2000;
  }

  public hiddenTag(): void {
    const expirationDate = new Date();
    expirationDate.setHours(expirationDate.getHours() + 21);

    const hiddenTagData = {
      value: true,
      expirationDate: expirationDate,
    };

    localStorage.setItem('hiddenTag', JSON.stringify(hiddenTagData));
    this.desabilitar = true;
  }

  public isHiddenTagValid(): boolean {
    const hiddenTagDataString = localStorage.getItem('hiddenTag');

    if (!hiddenTagDataString) {
      return false; // Se não houver dados, a tag não está definida
    }

    const hiddenTagData = JSON.parse(hiddenTagDataString);
    const expirationDate = new Date(hiddenTagData.expirationDate);

    return expirationDate > new Date(); // Retorna true se ainda estiver dentro do prazo
  }
}
